import React from 'react';
import Carousel from '../../components/Carousel/Carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faMailBulk, faPhoneSquareAlt, faFax } from '@fortawesome/free-solid-svg-icons';
import './Home.css';

const Home = () => {
  return (
    <>
      <Carousel />
      
      <div className="bizler_section_wrapper">
        <div className="container content-container">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <div className="home-content">
              <section className="contact-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="company-info">
                        <h3 className="company-title">Teknoma Teknolojik Malzemeler San. Tic. Ltd. Şti.​</h3>
                        <ul className="contact-info-list">
                          <li>
                            <FontAwesomeIcon icon={faLocationArrow} className="icon" />
                            <span>İzmir Teknoloji Geliştirme Bölgesi İYTE Kampüsü, 35430, Urla, İzmir</span>
                          </li>
                          <li>
                            <FontAwesomeIcon icon={faMailBulk} className="icon" />
                            <span>info@teknoma.net</span>
                          </li>
                          <li>
                            <FontAwesomeIcon icon={faPhoneSquareAlt} className="icon" />
                            <span>+90 (232) 765 90 01</span>
                          </li>
                          <li>
                            <FontAwesomeIcon icon={faFax} className="icon" />
                            <span>+90 (232) 765 90 02</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="google-map">
                        <iframe
                          src="https://maps.google.com/maps?q=G%C3%BClbah%C3%A7e%2C%20%C4%B0zmir%20Teknoloji%20Geli%C5%9Ftirme%20B%C3%B6lgesi%20%C4%B0zmir%20Y%C3%BCksek%20Teknoloji%20Enstit%C3%BCs%C3%BC%2C%2035437%20Urla%2F%C4%B0zmir&t=m&z=15&output=embed&iwloc=near"
                          title="Gülbahçe, İzmir Teknoloji Geliştirme Bölgesi İzmir Yüksek Teknoloji Enstitüsü, 35437 Urla/İzmir"
                          aria-label="Gülbahçe, İzmir Teknoloji Geliştirme Bölgesi İzmir Yüksek Teknoloji Enstitüsü, 35437 Urla/İzmir"
                          width="100%"
                          height="300"
                          frameBorder="0"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;